import { render, staticRenderFns } from "./Pieddepage.vue?vue&type=template&id=06c72f72"
import script from "./Pieddepage.vue?vue&type=script&lang=js"
export * from "./Pieddepage.vue?vue&type=script&lang=js"
import style0 from "./Pieddepage.vue?vue&type=style&index=0&id=06c72f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports